__turbopack_context__.v({
  "verifiedBlue": "verified-badge-module__mQaUqq__verifiedBlue",
  "verifiedGovernment": "verified-badge-module__mQaUqq__verifiedGovernment",
  "verifiedOld": "verified-badge-module__mQaUqq__verifiedOld",
});
